import React, { ReactNode } from 'react';

/**
 * Replaces newline characters (\n) with <br /> elements in Contentful Rich Text render output.
 *
 * These newlines are inserted in the rich text editor when using SHIFT+ENTER.
 *
 * @param text - The string containing newline characters to be processed
 * @returns An array of strings and JSX elements with <br /> tags inserted between text segments
 *
 * @example
 * // Use with documentToReactTree:
 * documentToReactTree(document, undefined, {
 *   renderText: insertLineBreakElements,
 * });
 */
export const newLinesToHtmlBr = (text: string): ReactNode => {
  return text.split('\n').reduce<ReactNode[]>((children, textSegment: string, index: number) => {
    return [...children, index > 0 && <br key={index} />, textSegment];
  }, []);
};